import './LevelTip.css'

export interface LevelTipProps {
	level: number;
	name: string;
	text: string | number;
	isHighlited?: boolean;
}

export const LevelTip = ({ level, name, text, isHighlited }: LevelTipProps) => {

	return (
		<div className={`level-tip`}>
			<div className='level-tip-level'>
				<img src={`/ranks/${level}.webp`}/>
				<p>{name}</p>
			</div>
			<div className='level-tip-text'>
				<p>{text}</p>
			</div>

			{isHighlited && <div className='level-tip-highlite'></div>}
		</div>
	)
}